import InfoTooltip from "components/InfoTooltip";
import React, { useEffect, useRef, useState } from "react";
import { ReactJewishDatePicker } from "react-jewish-datepicker";
import "./HebrewDatePicker.scss";

const HebrewDatePicker = ({ title, name, date, defaultValue, hint, ...props }) => {
  const hebrewDate = useRef(null);
  useEffect(() => {
    const element = hebrewDate.current.children[1].children[0].textContent;
    props.handleChange(element);
  }, []);
  return (
    <>
      <div className="customHebrewDate" ref={hebrewDate}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <label className={`label-style${hint ? " label-style--with-hint" : ""}`}>{title}</label>
          {hint && <InfoTooltip text={hint} style={{ marginLeft: '6px', transform: 'translateY(-3.5px)' }} />}
        </div>
        <ReactJewishDatePicker
          value={defaultValue ? undefined : date ? new Date(date) : new Date()}
          // isHebrew
          tite={title}
          name={name}
          className="hebrew-date-picker hebrew-date-of-dath"
          placeholder={defaultValue}
          {...props}
        />
      </div>
    </>
  );
};

export default HebrewDatePicker;
